import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class EstimatedIncomesService {
  constructor(private http: HttpClientService) {}

  public getEstimatedIncome(estimated_income_id: number | string): Observable<any> {
    return this.http
      .get(`/api/estimated_incomes/${estimated_income_id}`, {})
      .pipe(tap((_) => console.log("EstimatedIncomesService.getEstimatedIncome: Ok")));
  }

  public putEstimatedIncomes({
    id,
    minimum_income_needed = null,
    last_step = null,
    estimation_range = null,
    used_in_quoter = null,
    document_ids = null,
    estimation_trials = null,
    ready_for_estimation = null,
    quote = null,
  }): Observable<any> {
    return this.http
      .put(`/api/estimated_incomes/${id}`, {
        id,
        minimum_income_needed,
        last_step,
        estimation_range,
        used_in_quoter,
        document_ids,
        estimation_trials,
        ready_for_estimation,
        quote,
      })
      .pipe(tap((_) => console.log("EstimatedIncomesService.putEstimatedIncomes: Ok")));
  }

  public calculateIncomeThresholds(estimated_income_id: number | string): Observable<any> {
    return this.http
      .post(`/api/estimated_incomes/${estimated_income_id}/calculate_income_thresholds`, {})
      .pipe(tap((_) => console.log("EstimatedIncomesService.calculateIncomeThresholds: Ok")));
  }
}
